export const getProductSelectedByDrugManufacturerId = (
    id: string | number,
    products: any[],
    EX5937: boolean,
): any[] => {
    return (
        products?.flatMap(({ drugManufacturerIdSelected, generics, ...rest }) => {
            const result = [];

            // Si el producto principal coincide, lo incluimos
            const mainMatch = Array.isArray(drugManufacturerIdSelected)
                ? drugManufacturerIdSelected.includes(id)
                : drugManufacturerIdSelected === id;

            if (mainMatch) result.push({ drugManufacturerIdSelected, generics, ...rest });

            // Si existen generics y alguno coincide, los incluimos individualmente
            if (EX5937 && generics?.length > 0) {
                const genericsMatches = generics.filter(({ drugManufacturerIdSelected }) =>
                    Array.isArray(drugManufacturerIdSelected)
                        ? drugManufacturerIdSelected.includes(id)
                        : drugManufacturerIdSelected === id,
                );

                result.push(...genericsMatches);
            }

            return result;
        }) || []
    );
};
